export var backgroundTextureRedPaper = '_1yvX5';
export var transformClipsUp = '_1IE8w';
export var paperShadow = '_1epdG';
export var tiltRight = '_3pFxs';
export var tiltLeft = 'yZlZ5';